const stages = [

  //----------------------Stage -----------------------------------
  {
    a: 2,
    b: 9,
  },
  {
    a: 3,
    b: 3,
  },
   {
    a: 2,
    b: 2,
  },
  {
    a: 4,
    b: 2,
  },
  {
    a: 2,
    b: 3,
  },
  {
    a: 3,
    b: 8,
  },
  {
    a: 6,
    b: 3,
  },
  {
    a: 4,
    b: 3,
  }, 
  {
    a: 9,
    b: 3,
  },
  {
    a: 3,
    b: 5,
  },
   {
    a: 2,
    b: 10,
  },
  {
    a: 6,
    b: 2,
  },
  {
    a: 6,
    b: 3,
  },
  {
    a: 2,
    b: 5,
  },
  {
    a: 3,
    b: 2,
  },
  {
    a: 3,
    b: 4,
  },
  {
    a: 6,
    b: 3,
  },
  {
    a: 4,
    b: 2,
  }, 
  {
    a: 12,
    b: 3,
  },
  {
    a: 3,
    b: 8,
  },
   {
    a: 2,
    b: 12,
  },
  {
    a: 11,
    b: 2,
  },
  {
    a: 7,
    b: 3,
  },
  {
    a: 3,
    b: 5,
  },
  {
    a: 2,
    b: 5,
  },
  {
    a: 3,
    b: 6,
  },
  {
    a: 6,
    b: 2,
  },
  {
    a: 3,
    b: 12,
  }, 
  {
    a: 2,
    b: 3,
  },
  {
    a: 3,
    b: 5,
  },
   {
    a: 2,
    b: 4,
  },
  {
    a: 2,
    b: 6,
  },
  {
    a: 12,
    b: 2,
  },
  {
    a: 4,
    b: 2,
  },
  {
    a: 3,
    b: 11,
  },
  {
    a: 5,
    b: 3,
  },
  {
    a: 2,
    b: 9,
  },
  {
    a: 3,
    b: 8,
  }, 
  {
    a: 8,
    b: 2,
  },
  {
    a: 3,
    b: 3,
  },
   {
    a: 2,
    b: 2,
  },
  {
    a: 2,
    b: 6,
  },
  {
    a: 2,
    b: 6,
  },
  {
    a: 4,
    b: 2,
  },
  {
    a: 2,
    b: 6,
  },
  {
    a: 8,
    b: 2,
  },
  {
    a: 7,
    b: 2,
  },
  {
    a: 5,
    b: 2,
  },
  {
    a: 12,
    b: 3,
  },
  
  {
    a: 7,
    b: 3
  },



  //----------------------Stage 2-----------------------------------
  {
    a: 4,
    b: 9,
  },
  {
    a: 3,
    b: 5,
  },
   {
    a: 4,
    b: 3,
  },
  {
    a: 4,
    b: 7,
  },
  {
    a: 9,
    b: 3,
  },
  {
    a: 5,
    b: 8,
  },
  {
    a: 6,
    b: 4,
  },
  {
    a: 10,
    b: 3,
  }, 
  {
    a: 9,
    b: 5,
  },
  {
    a: 4,
    b: 5,
  },
   {
    a: 5,
    b: 10,
  },
  {
    a: 6,
    b: 4,
  },
  {
    a: 6,
    b: 5,
  },
  {
    a: 12,
    b: 5,
  },
  {
    a: 4,
    b: 12,
  },
  {
    a: 3,
    b: 4,
  },
  {
    a: 6,
    b: 5,
  },
  {
    a: 7,
    b: 5,
  }, 
  {
    a: 4,
    b: 11,
  },
  {
    a: 12,
    b: 5,
  },
   {
    a: 6,
    b: 4,
  },
  {
    a: 5,
    b: 5,
  },
  {
    a: 4,
    b: 4,
  },
  {
    a: 4,
    b: 11,
  },
  {
    a: 5,
    b: 9,
  },
  {
    a: 5,
    b: 11,
  },
  {
    a: 6,
    b: 3,
  },
  {
    a: 5,
    b: 6,
  }, 
  {
    a: 4,
    b: 5,
  },
  {
    a: 5,
    b: 13,
  },
   {
    a: 5,
    b: 14,
  },
  {
    a: 4,
    b: 12,
  },
  {
    a: 13,
    b: 3,
  },
  {
    a: 9,
    b: 4,
  },
  {
    a: 3,
    b: 4,
  },
  {
    a: 5,
    b: 3,
  },
  {
    a: 5,
    b: 12,
  },
  {
    a: 14,
    b: 2,
  }, 
  {
    a: 14,
    b: 3,
  },
  {
    a: 13,
    b: 3,
  },
   {
    a: 12,
    b: 4,
  },
  {
    a: 5,
    b: 2,
  },
  {
    a: 2,
    b: 13,
  },
  {
    a: 2,
    b: 16,
  },
  {
    a: 3,
    b: 8,
  },
  {
    a: 6,
    b: 5,
  },
  {
    a: 15,
    b: 3,
  },
  {
    a: 15,
    b: 2,
  },
  {
    a: 4,
    b: 13,
  },
  
  {
    a: 14,
    b: 3
  },


//-----------------Stage 3-----------------------------

  {
    a: 7,
    b: 9,
  },
  {
    a: 3,
    b: 6,
  },
   {
    a: 2,
    b: 7,
  },
  {
    a: 4,
    b: 6,
  },
  {
    a: 7,
    b: 3,
  },
  {
    a: 5,
    b: 8,
  },
  {
    a: 6,
    b: 6,
  },
  {
    a: 4,
    b: 7,
  }, 
  {
    a: 9,
    b: 6,
  },
  {
    a: 7,
    b: 5,
  },
   {
    a: 6,
    b: 10,
  },
  {
    a: 6,
    b: 7,
  },
  {
    a: 6,
    b: 6,
  },
  {
    a: 7,
    b: 5,
  },
  {
    a: 3,
    b: 6,
  },
  {
    a: 7,
    b: 4,
  },
  {
    a: 6,
    b: 12,
  },
  {
    a: 4,
    b: 13,
  }, 
  {
    a: 12,
    b: 7,
  },
  {
    a: 6,
    b: 5,
  },
   {
    a: 6,
    b: 4,
  },
  {
    a: 5,
    b: 9,
  },
  {
    a: 4,
    b: 7,
  },
  {
    a: 9,
    b: 6,
  },
  {
    a: 5,
    b: 11,
  },
  {
    a: 11,
    b: 6,
  },
  {
    a: 6,
    b: 13,
  },
  {
    a: 7,
    b: 6,
  }, 
  {
    a: 6,
    b: 3,
  },
  {
    a: 8,
    b: 5,
  },
   {
    a: 5,
    b: 6,
  },
  {
    a: 4,
    b: 7,
  },
  {
    a: 6,
    b: 8,
  },
  {
    a: 10,
    b: 4,
  },
  {
    a: 13,
    b: 4,
  },
  {
    a: 6,
    b: 13,
  },
  {
    a: 7,
    b: 7,
  },
  {
    a: 9,
    b: 6,
  }, 
  {
    a: 4,
    b: 6,
  },
  {
    a: 7,
    b: 13,
  },
   {
    a: 5,
    b: 14,
  },
  {
    a: 5,
    b: 6,
  },
  {
    a: 7,
    b: 3,
  },
  {
    a: 8,
    b: 6,
  },
  {
    a: 12,
    b: 6,
  },
  {
    a: 6,
    b: 13,
  },
  {
    a: 5,
    b: 3,
  },
  {
    a: 5,
    b: 12,
  },
  {
    a: 6,
    b: 11,
  },
  
  {
    a: 7,
    b: 13
  },


  //-----------------Stage 4-----------------------------
  {
    a: 9,
    b: 9,
  },
  {
    a: 8,
    b: 6,
  },
   {
    a: 9,
    b: 7,
  },
  {
    a: 8,
    b: 6,
  },
  {
    a: 7,
    b: 9,
  },
  {
    a: 8,
    b: 8,
  },
  {
    a: 6,
    b: 6,
  },
  {
    a: 8,
    b: 7,
  }, 
  {
    a: 9,
    b: 8,
  },
  {
    a: 7,
    b: 9,
  },
   {
    a: 8,
    b: 10,
  },
  {
    a: 6,
    b: 7,
  },
  {
    a: 6,
    b: 9,
  },
  {
    a: 7,
    b: 8,
  },
  {
    a: 3,
    b: 9,
  },
  {
    a: 7,
    b: 6,
  },
  {
    a: 6,
    b: 8,
  },
  {
    a: 8,
    b: 13,
  }, 
  {
    a: 12,
    b: 9,
  },
  {
    a: 6,
    b: 8,
  },
   {
    a: 9,
    b: 4,
  },
  {
    a: 5,
    b: 9,
  },
  {
    a: 4,
    b: 8,
  },
  {
    a: 9,
    b: 6,
  },
  {
    a: 5,
    b: 9,
  },
  {
    a: 11,
    b: 8,
  },
  {
    a: 8,
    b: 13,
  },
  {
    a: 7,
    b: 9,
  }, 
  {
    a: 6,
    b: 8,
  },
  {
    a: 8,
    b: 5,
  },
   {
    a: 9,
    b: 6,
  },
  {
    a: 9,
    b: 7,
  },
  {
    a: 6,
    b: 8,
  },
  {
    a: 10,
    b: 9,
  },
  {
    a: 13,
    b: 9,
  },
  {
    a: 8,
    b: 13,
  },
  {
    a: 7,
    b: 8,
  },
  {
    a: 9,
    b: 8,
  }, 
  {
    a: 4,
    b: 6,
  },
  {
    a: 9,
    b: 13,
  },
   {
    a: 5,
    b: 14,
  },
  {
    a: 5,
    b: 8
  },
  {
    a: 8,
    b: 3,
  },
  {
    a: 8,
    b: 8,
  },
  {
    a: 12,
    b: 8,
  },
  {
    a: 9,
    b: 13,
  },
  {
    a: 8,
    b: 13,
  },
  {
    a: 9,
    b: 12,
  },
  {
    a: 9,
    b: 11,
  },
  
  {
    a: 8,
    b: 12
  },


  //-----------------Stage 5-----------------------------
  {
    a: 9,
    b: 11,
  },
  {
    a: 8,
    b: 10,
  },
   {
    a: 9,
    b: 11,
  },
  {
    a: 11,
    b: 10,
  },
  {
    a: 10,
    b: 14,
  },
  {
    a: 8,
    b: 13,
  },
  {
    a: 9,
    b: 12,
  },
  {
    a: 12,
    b: 11,
  }, 
  {
    a: 10,
    b: 8,
  },
  {
    a: 11,
    b: 9,
  },
   {
    a: 12,
    b: 10,
  },
  {
    a: 11,
    b: 7,
  },
  {
    a: 6,
    b: 10,
  },
  {
    a: 9,
    b: 8,
  },
  {
    a: 11,
    b: 9,
  },
  {
    a: 11,
    b: 6,
  },
  {
    a: 10,
    b: 9,
  },
  {
    a: 8,
    b: 12,
  }, 
  {
    a: 12,
    b: 11,
  },
  {
    a: 11,
    b: 8,
  },
   {
    a: 9,
    b: 13,
  },
  {
    a: 5,
    b: 11,
  },
  {
    a: 4,
    b: 10,
  },
  {
    a: 11,
    b: 6,
  },
  {
    a: 8,
    b: 9,
  },
  {
    a: 11,
    b: 9,
  },
  {
    a: 11,
    b: 13,
  },
  {
    a: 6,
    b: 9,
  }, 
  {
    a: 11,
    b: 8,
  },
  {
    a: 8,
    b: 11,
  },
   {
    a: 9,
    b: 10,
  },
  {
    a: 9,
    b: 10,
  },
  {
    a: 6,
    b: 8,
  },
  {
    a: 10,
    b: 9,
  },
  {
    a: 13,
    b: 9,
  },
  {
    a: 8,
    b: 13,
  },
  {
    a: 7,
    b: 8,
  },
  {
    a: 9,
    b: 8,
  }, 
  {
    a: 4,
    b: 6,
  },
  {
    a: 9,
    b: 13,
  },
   {
    a: 5,
    b: 14,
  },
  {
    a: 5,
    b: 8
  },
  {
    a: 8,
    b: 3,
  },
  {
    a: 8,
    b: 8,
  },
  {
    a: 12,
    b: 8,
  },
  {
    a: 9,
    b: 13,
  },
  {
    a: 8,
    b: 13,
  },
  {
    a: 9,
    b: 12,
  },
  {
    a: 9,
    b: 11,
  },
  
  {
    a: 8,
    b: 12
  },
];


module.exports = {
  stages
};









/* 
const stageTwo = [
  {
    a: 7,
    b: 3,
  },
  {
    a: 6,
    b: 5,
  },
   {
    a: 5,
    b: 4,
  },
  {
    a: 5,
    b: 6,
  },
  {
    a: 4,
    b: 3,
  },
  {
    a: 4,
    b: 8,
  },
  {
    a: 2,
    b: 7,
  },
  {
    a: 8,
    b: 3,
  },
  {
    a: 5,
    b: 7,
  },
  {
    a: 4,
    b: 5,
  }, 
  {
    a: 7,
    b: 3,
  },
  {
    a: 8,
    b: 5,
  },
   {
    a: 7,
    b: 4,
  },
  {
    a: 6,
    b: 7,
  },
  {
    a: 4,
    b: 8,
  },
  {
    a: 6,
    b: 5,
  },
  {
    a: 3,
    b: 8,
  },
  {
    a: 3,
    b: 4,
  },
  {
    a: 6,
    b: 6,
  },
  {
    a: 4,
    b: 8,
  }, 
  {
    a: 7,
    b: 3,
  },
  {
    a: 7,
    b: 7,
  },
   {
    a: 5,
    b: 4,
  },
  {
    a: 5,
    b: 8,
  },
  {
    a: 4,
    b: 7,
  },
  {
    a: 8,
    b: 8,
  },
  {
    a: 5,
    b: 8,
  },
  {
    a: 4,
    b: 6,
  },
  {
    a: 8,
    b: 3,
  },
  {
    a: 7,
    b: 6,
  }, 
  {
    a: 4,
    b: 8,
  },
  {
    a: 6,
    b: 5,
  },
   {
    a: 5,
    b: 4,
  },
  {
    a: 4,
    b: 6,
  },
  {
    a: 3,
    b: 8,
  },
  {
    a: 8,
    b: 8,
  },
  {
    a: 3,
    b: 6,
  },
  {
    a: 5,
    b: 5,
  },
  {
    a: 6,
    b: 7,
  },
  {
    a: 8,
    b: 6,
  }, 
  {
    a: 4,
    b: 7,
  },
  {
    a: 7,
    b: 7,
  },
   {
    a: 5,
    b: 7,
  },
  {
    a: 6,
    b: 6,
  },
  {
    a: 2,
    b: 7,
  },
  {
    a: 4,
    b: 6,
  },
  {
    a: 2,
    b: 8,
  },
  {
    a: 6,
    b: 7,
  },
  {
    a: 8,
    b: 3,
  },
  {
    a: 7,
    b: 8,
  }
]; */